import React, { useImperativeHandle, forwardRef, useState, useRef, } from 'react';

const Confetti = forwardRef((props, ref) => {
    const [streamingConfetti, setStreamingConfetti] = useState(false);
    const canvasRef = useRef(null);
    const animationTimer = useRef(null);
    const particles = useRef([]);
    const maxParticleCount = 150;
    const particleSpeed = 5;
    const colors = [
        "DodgerBlue", "OliveDrab", "Gold", "Pink", "SlateBlue", "LightBlue",
        "Violet", "PaleGreen", "SteelBlue", "SandyBrown", "Chocolate", "Crimson"
    ];
    let waveAngle = useRef(0);

    useImperativeHandle(ref, () => ({
        startConfetti: startConfetti,
        stopConfetti: stopConfetti,
    }));

    const resetParticle = (width, height) => {
        return {
            color: colors[Math.floor(Math.random() * colors.length)],
            x: Math.random() * width,
            y: Math.random() * height - height,
            diameter: Math.random() * 5 + 2,
            tilt: Math.random() * 10 - 10,
            tiltAngleIncrement: Math.random() * 0.07 + 0.05,
            tiltAngle: 0,
            opacity: Math.random() * 0.5 + 0.5,
        };
    };

    const startConfetti = () => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");
        particles.current = [];

        for (let i = 0; i < maxParticleCount; i++) {
            particles.current.push(resetParticle(width, height));
        }
        // Make sure the canvas is visible
        canvasRef.current.style.display = 'block';
        const runAnimation = () => {
            context.clearRect(0, 0, width, height);
            if (particles.current.length === 0) {
                return;
            }
            updateParticles(width, height);
            drawParticles(context);
            animationTimer.current = requestAnimationFrame(runAnimation);
        };
        runAnimation();
    };

    const stopConfetti = () => {
        fadeOutParticles();
        if (animationTimer.current) {
            cancelAnimationFrame(animationTimer.current);
        }
        // fadeOutParticles();
        // setTimeout(() => {
        //   fadeOutParticles();
        // }, 1); 
    };

    const fadeOutParticles = () => {
        let fadeInterval = setInterval(() => {
            if (particles.current.length === 0) {
                clearInterval(fadeInterval);
                canvasRef.current.style.display = 'none';
            }
            particles.current.forEach((particle, index) => {
                if (particle.opacity <= 0 || particle.y > window.innerHeight + 20) {
                    particles.current.splice(index, 1);
                } else {
                    particle.opacity -= 0.05;
                    particle.x += Math.sin(waveAngle.current);
                    particle.y += (Math.cos(waveAngle.current) + particle.diameter + particleSpeed) * 0.5;
                }
            });


        }, 0);
    };

    const updateParticles = (width, height) => {
        waveAngle.current += 0.01;
        particles.current.forEach((particle, index) => {
            if (particle.y < -15) {
                particle.y = height + 100;
            } else {
                particle.tiltAngle += particle.tiltAngleIncrement;
                particle.x += Math.sin(waveAngle.current);
                particle.y += (Math.cos(waveAngle.current) + particle.diameter + particleSpeed) * 0.5;
                particle.tilt = Math.sin(particle.tiltAngle) * 15;
            }
            if (particle.x > width + 20 || particle.x < -20 || particle.y > height) {
                particles.current[index] = resetParticle(width, height);
            }
        });
    };

    const drawParticles = (context) => {
        particles.current.forEach((particle) => {
            context.beginPath();
            context.lineWidth = particle.diameter;
            context.strokeStyle = particle.color;
            context.globalAlpha = particle.opacity;
            const x = particle.x + particle.tilt;
            context.moveTo(x + particle.diameter / 2, particle.y);
            context.lineTo(x, particle.y + particle.tilt + particle.diameter / 2);
            context.stroke();
        });
    };

    return <canvas ref={canvasRef} id="confetti-canvas" style={{ position: 'fixed', top: 0, left: 0, pointerEvents: 'none', zIndex: 999999 }} width={window.innerWidth} height={window.innerHeight} />;
});

export default Confetti;
